import React from "react"

const Linkedin = ({ color = "default" }) => {
  const strokeColor = color === "dark" ? "#ffffff" : "#121212"
  const iconColor = color === "dark" ? "#ffffff" : "#121212"

  return (
    <svg
      width="61"
      height="60"
      viewBox="0 0 61 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transition: "all 0.3s ease",
        cursor: "pointer",
      }}
      onMouseEnter={e => {
        const rect = e.currentTarget.querySelector("rect")
        const path = e.currentTarget.querySelector("path")
        if (rect) {
          rect.setAttribute("fill", strokeColor)
        }
        if (path) {
          path.setAttribute("fill", color === "dark" ? "#121212" : "#ffffff")
        }
      }}
      onMouseLeave={e => {
        const rect = e.currentTarget.querySelector("rect")
        const path = e.currentTarget.querySelector("path")
        if (rect) {
          rect.setAttribute("fill", "none")
        }
        if (path) {
          path.setAttribute("fill", iconColor)
        }
      }}
    >
      <rect
        x="1.53027"
        y="1"
        width="57.9698"
        height="58"
        rx="28.9849"
        stroke={strokeColor}
        strokeWidth="2"
        fill="none"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.5522 42H37.3685V33.8792C37.3685 31.9428 37.3328 29.4516 34.6729 29.4516C31.9738 29.4516 31.5594 31.5612 31.5594 33.7391V42H26.3766V25.3009H31.3518V27.5826H31.4213C32.1139 26.2698 33.806 24.8857 36.3295 24.8857C41.5823 24.8857 42.5522 28.3446 42.5522 32.8405V42ZM20.5303 23.0182C18.8677 23.0182 17.522 21.6697 17.522 20.0083C17.522 18.3486 18.8677 17 20.5303 17C22.1886 17 23.5364 18.3486 23.5364 20.0083C23.5364 21.6697 22.1886 23.0182 20.5303 23.0182ZM17.9356 42H23.1232V25.3009H17.9356V42Z"
        fill={iconColor}
      />
    </svg>
  )
}

export default Linkedin
